export default "__VITE_ASSET__BtwLwTin__"